/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Baobei_De_BeiInputs */

const en_testimonial_baobei_de_bei = /** @type {(inputs: Testimonial_Baobei_De_BeiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazing! This is my new favorite app! Uploading PDFs is so easy on the phone, and the narration sounds very natural! Perfect for listening to academic papers (or any other texts)—so convenient and saves so much time!`)
};

const es_testimonial_baobei_de_bei = /** @type {(inputs: Testimonial_Baobei_De_BeiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Increíble! ¡Esta es mi nueva app favorita! Subir PDFs es súper fácil en el teléfono, y la narración suena muy natural. ¡Perfecta para escuchar artículos académicos (o cualquier otro texto), tan conveniente y ahorra mucho tiempo!`)
};

/**
* | output |
* | --- |
* | "Amazing! This is my new favorite app! Uploading PDFs is so easy on the phone, and the narration sounds very natural! Perfect for listening to academic papers..." |
*
* @param {Testimonial_Baobei_De_BeiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_baobei_de_bei = /** @type {((inputs?: Testimonial_Baobei_De_BeiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Baobei_De_BeiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_baobei_de_bei(inputs)
	return en_testimonial_baobei_de_bei(inputs)
});